export enum HallowAnalyticsHandler {
  Close = "close",
  Track = "track",
  TrackPayment = "trackPayment",
}
